import { authPageContainerClass } from "@/layout/auth-layout.styles";
import { Button, Typography } from "@iluvatar/ui-kit";

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { useAuthenticationContext } from "../contexts/authentication/authentication.context";

// styles

function LogoutPage(): JSX.Element {
  const { logout } = useAuthenticationContext();
  const navigate = useNavigate();

  const [error, setError] = useState<string>();
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    logout()
      .then(() => {
        if (active) {
          navigate({ to: "/login" });
        }
      })
      .catch((failure: unknown) => {
        if (active) {
          setError(
            failure instanceof Error
              ? failure.message
              : "Could not log out. Please try again.",
          );
        }
      });
    return () => {
      active = false;
    };
  }, [logout, navigate, attempt]);

  return (
    <div className={`${authPageContainerClass}`}>
      <Typography variant="h5">{error || "Logging out"}</Typography>
      {error && (
        <Button
          variant="outline"
          onClick={() => {
            setError(undefined);
            setAttempt((value) => value + 1);
          }}
        >
          Retry logout
        </Button>
      )}
    </div>
  );
}

export const Route = createFileRoute("/logout")({
  component: LogoutPage,
});
